import { TTheme } from '@/core/theme'
import SearchIcon from '@assets/images/search-icon.svg?react'
import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const Body = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 36px 0;
    min-width: 0;
    max-height: 100%;

    .autocomplete {
        background-color: transparent;
        border: 1px solid
            ${({ theme }) => theme.colors.semantic.drawerSeparator};

        border-radius: 4px;
        height: 48px;
        .MuiAutocomplete-endAdornment {
            margin: 3px 12px 0 0;

            .MuiSvgIcon-root {
                width: 14px;
                height: 14px;
                align-items: center;
            }
        }

        .MuiAutocomplete-popupIndicator {
            display: none;
        }
        .MuiFormControl-root {
            height: 100%;
        }
        .MuiInputBase-root {
            display: flex;
            height: 100%;
            padding: 0 16px;
        }
    }
`

export const SelectedTechnologiesWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    overflow: auto;
`

export const SelectedTechnology = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;

    .remove-icon {
        cursor: pointer;
    }
`

export const Flex = styled('div')`
    display: flex;
    gap: 8px;
    align-items: center;
`

export const InputWrapper = styled('div')`
    position: relative;
`

export const StyledSearchIcon = styled(SearchIcon)`
    position: absolute;
    right: 15px;
    top: 17px;
`

export const Title = styled(Typography)`
    min-height: 30px;
`
